export default function Close() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#626262" />
            <path d="M8.51953 7.95508L15.832 15.2676M15.832 7.95508L8.51953 15.2676" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
